// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2411":"a8da5055","3013":"a8da5055","4056":"a8da5055","4441":"a8da5055","8597":"a8da5055","8623":"a8da5055","9245":"33ba5c92"}[chunkId] + ".chunk.css";
};